<template>
  <div class="">
    <Navbar />
    <section class="admin-content">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-edit-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Edit Enrollee</h4>
              <small style="opacity: .8;">Update enrollee bio data and coverage information</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <div class="row">
          <div class="col-lg-10 mx-auto">

            <div class="card table-card shadow mb-4">
              <div class="form-card-header">
                <div class="section-number">1</div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Personal Data</p>
                  <small style="color:rgba(255,255,255,.7);">Update enrollee bio information</small>
                </div>
              </div>
              <div class="card-body">

                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Sector Type: {{ auth_user.sectorType }}</label>
                      <select class="form-control" v-model="auth_user.sectorType">
                        <option value="formal">Formal Sector</option>
                        <option value="informal">Informal Sector</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Plan Type <span class="text-danger">*</span></label>
                      <select class="form-control" required v-model="auth_user.plan_type">
                        <option value="Family">Family</option>
                        <option value="Individual">Individual</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6" v-if="user.user_role != 0">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Sector</label>
                      <select class="form-control" v-model="auth_user.sector">
                        <option :value="sec" v-for="sec in sectorOptions" :key="sec">{{ sec }}</option>
                      </select>
                      <small class="text-muted">All of the agency's programmes (Manage Plans) and those enrollees are on.</small>
                    </div>
                  </div>

                  <div class="form-group col-md-6" v-if="auth_user.sectorType == 'informal'">
                    <label class="info-label d-block mb-1">Special Needs</label>
                    <select class="form-control" v-model="auth_user.category_of_vulnerable_group">
                      <option value="Pregnant Women">Pregnant Women</option>
                      <option value="Children under 5">Children under 5</option>
                      <option value="Aged">Aged</option>
                      <option value="IDP">IDP</option>
                      <option value="Physically Challenged">Physically Challenged</option>
                      <option value="People with Special Needs">People with Special Needs</option>
                      <option value="Poorest of the Poor">Poorest of the Poor</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6" v-if="user.type == 'shis' || user.user_role == 1">
                    <label class="info-label d-block mb-1">RIVCHPP Number</label>
                    <input type="text" class="form-control" readonly placeholder="RIVCHPP Number" v-model="auth_user.id_card_number" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Surname</label>
                    <input type="text" v-model="auth_user.lastname" class="form-control" placeholder="Last Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">First Name</label>
                    <input type="text" v-model="auth_user.firstname" class="form-control" placeholder="First Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Middle Name</label>
                    <input type="text" v-model="auth_user.middlename" class="form-control" placeholder="Middle Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Email</label>
                    <input type="email" class="form-control" placeholder="Email" v-model="auth_user.email" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Phone Number</label>
                    <input v-phone type="text" class="form-control" placeholder="Phone Number" v-model="auth_user.phone_number" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">NIN Number</label>
                    <input type="text" class="form-control" placeholder="NIN Number" v-model="auth_user.nimc_number" />
                  </div>

                  <div class="form-group col-md-6" v-if="user.user_role == 1">
                    <label class="info-label d-block mb-1">Computer Number / Salary Number</label>
                    <input type="text" class="form-control" placeholder="Computer Number" v-model="auth_user.salary_number" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Place of Work</label>
                    <v-select v-model="auth_user.place_of_work" :options="mdas" :reduce="(name) => name.name" label="name"></v-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Date of Birth</label>
                    <input type="date" class="form-control" v-model="auth_user.dob" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">
                      Date of Expiry: <strong>{{ auth_user.expiry_date }}</strong>
                    </label>
                    <input type="date" class="form-control" v-model="auth_user.expiry_date" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Gender</label>
                    <select class="form-control" v-model="auth_user.gender">
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Marital Status</label>
                    <select class="form-control" v-model="auth_user.marital_status">
                      <option value="Married">Married</option>
                      <option value="Widow">Widow</option>
                      <option value="Single">Single</option>
                      <option value="Divorced">Seperated</option>
                      <option value="Divorced">Divorced</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Blood Group</label>
                    <select class="form-control" v-model="auth_user.blood">
                      <option :value="null">Not known</option>
                      <option v-for="g in bloodGroupOptions" :key="g.value" :value="g.value">{{ g.label }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Genotype</label>
                    <select class="form-control" v-model="auth_user.genotype">
                      <option :value="null">Not known</option>
                      <option v-for="g in genotypeOptions" :key="g" :value="g">{{ g }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-12">
                    <label class="info-label d-block mb-1">Facility <span class="text-danger">*</span></label>
                    <v-select
                      v-model="auth_user.provider_id"
                      :options="providers"
                      label="agency_name"
                      :reduce="p => p.id"
                      placeholder="Select facility…"
                      @input="onProviderChange"
                    ></v-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">LGA</label>
                    <input type="text" class="form-control" :value="derivedLgaName" disabled
                      placeholder="Auto-filled from facility" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Ward</label>
                    <input type="text" class="form-control" :value="derivedWardName" disabled
                      placeholder="Auto-filled from facility" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Community</label>
                    <select class="form-control" v-model="auth_user.community" :disabled="!communities.length">
                      <option value="">-- Select Community --</option>
                      <option v-for="c in communities" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                  </div>

                  <!-- <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Select TPA/HMO <span class="text-danger">*</span></label>
                    <select class="form-control" required v-model="auth_user.org_id">
                      <option v-for="tpa in tpas" v-bind:key="tpa.id" :value="tpa.id">{{ tpa.organization_name }}</option>
                    </select>
                  </div> -->

                  <div class="form-group col-md-12" v-if="auth_user.type != 'client'">
                    <label class="info-label d-block mb-1">Company Name</label>
                    <input type="text" class="form-control" placeholder="Company Name" v-model="auth_user.agency_name" />
                  </div>

                  <div class="form-group col-md-12" v-if="auth_user.type == 'client'">
                    <label class="info-label d-block mb-1">Home Address</label>
                    <input type="text" class="form-control" v-model="auth_user.address1" placeholder="Address" />
                  </div>
                </div>

                <div class="pt-3 border-top">
                  <button type="submit" class="btn btn-submit px-5" @click="editUser">
                    <i class="fe fe-save mr-1"></i> Save Changes
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </section>
  </div>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        auth_user: "",
        providers: [],
        sectors: [
          "Basic Healthcare Provision Fund",
          "State Equity Program",
          "State Civil Servant",
          "LGA Civil Servant",
          "Tertiary Student Health Insurance Plan (T-SHIP)",
          "Rivcare",
          "Rivcare Basic",
          "Rivcare Premium",
          "Rivcare Premium Plus",
          "Organized Community Healthcare Plan",
          "Voluntary Contributor",
          "State Public Servant",
          "State Pensioners Plan",
          "T-SHIP",
          "CEmOC BHCPF",
          "Governor Sim Free Healthcare Workers Scheme",
          "SCIMA Sickle Cell Program",
        ],
        agencyProgrammes: [],
        user: null,
        image: "",
        sector: "",
        wards: [],
        communities: [],
        mdas: "",
        tpas: "",
        lga_states: "",
        isLoading: false,
        fullPage: true,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.getUser();
    },
    computed: {
      // Blood groups with the Rhesus factor, as on the enrolment forms; a stored value outside the list (older
      // records saved as "A", "O" …) stays selectable so saving the form doesn't change it.
      bloodGroupOptions() {
        const groups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((g) => ({ value: g, label: g }));
        const current = this.auth_user && this.auth_user.blood;
        if (current && !groups.some((g) => g.value === current)) groups.unshift({ value: current, label: current + " (as saved; please update)" });
        return groups;
      },
      genotypeOptions() {
        const list = ["AA", "AS", "AC", "SS", "SC", "CC"];
        const current = this.auth_user && this.auth_user.genotype;
        return current && !list.includes(current) ? [current, ...list] : list;
      },
      // Every programme: the fixed list, the agency's plans and programmes enrollees are on, and the enrollee's own.
      sectorOptions() {
        const seen = new Set();
        const out = [];
        [...this.sectors, ...this.agencyProgrammes, this.auth_user && this.auth_user.sector].forEach((name) => {
          const value = String(name || "").trim();
          const key = value.toLowerCase();
          if (value && !seen.has(key)) { seen.add(key); out.push(value); }
        });
        return out.sort((a, b) => a.localeCompare(b));
      },
      derivedLgaName() {
        if (!this.auth_user.provider_id || !this.providers.length) return "";
        const provider = this.providers.find(p => p.id === this.auth_user.provider_id);
        if (!provider || !provider.localgovt) return "";
        return typeof provider.localgovt === "object"
          ? provider.localgovt.local_name
          : (this.lga_states && this.lga_states.find(l => l.id === Number(provider.localgovt)))
            ? this.lga_states.find(l => l.id === Number(provider.localgovt)).local_name
            : "";
      },
      derivedWardName() {
        if (!this.auth_user.provider_id || !this.providers.length) return "";
        const provider = this.providers.find(p => p.id === this.auth_user.provider_id);
        if (!provider || !provider.ward) return "";
        return typeof provider.ward === "object" ? provider.ward.ward_name : "";
      },
      autoEmail() {
        if (this.auth_user.email == null) {
          let autogenemail =
            this.auth_user.phone_number + this.$route.params.id + "@ohisuser.com";
          return autogenemail;
        } else {
          return this.auth_user.email;
        }
      },
    },

    methods: {
      onProviderChange(providerId) {
        if (!providerId) return;
        const provider = this.providers.find(p => p.id === providerId);
        if (!provider) return;

        const lgId = provider.localgovt
          ? (typeof provider.localgovt === "object" ? provider.localgovt.id : Number(provider.localgovt))
          : null;
        if (lgId) this.auth_user.localgovt = lgId;

        const wardId = provider.ward
          ? (typeof provider.ward === "object" ? provider.ward.id : Number(provider.ward))
          : null;
        this.auth_user.ward = wardId ? wardId : "";

        const communityId = provider.community
          ? (typeof provider.community === "object" ? provider.community.id : Number(provider.community))
          : null;

        if (communityId) {
          this.communities = provider.community && typeof provider.community === "object"
            ? [provider.community]
            : this.communities;
          this.auth_user.community = communityId;
        } else {
          this.communities = [];
          this.auth_user.community = "";
          if (wardId) this.fetchCommunities(wardId);
        }
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/407465`, { params: { status: 1 } })
          .then((response) => {
            this.providers = response.data.data;
          })
          .catch(console.error);
      },

      fetchCommunities(wardId) {
        this.axios
          .get(`/api/v1/auth/communities`,{
            params: { ward_id: wardId }
          })
          .then((response) => {
            this.communities = response.data || [];
          })
          .catch(console.error);
      },

      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.auth_user.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/407465`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      // Plans of the agency (Manage Plans) and programmes enrollees are on without a plan.
      getAgencyProgrammes() {
        this.axios
          .get(`/api/v1/auth/agency-plans`)
          .then((response) => {
            const data = (response.data && response.data.data) || {};
            this.agencyProgrammes = [
              ...(data.plans || []).map((p) => p.title),
              ...(data.programmes_without_plan || []).map((p) => p.name),
            ];
          })
          .catch(() => { this.agencyProgrammes = []; });
      },
      getUser() {
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.auth_user = response.data.user;
            if (this.auth_user.localgovt) {
              this.auth_user.localgovt = Number(this.auth_user.localgovt);
            }
            if (this.auth_user.ward) {
              this.auth_user.ward = Number(this.auth_user.ward);
              this.fetchCommunities(this.auth_user.ward);
            }
            if (this.auth_user.community) {
              this.auth_user.community = Number(this.auth_user.community);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2679`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      editUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/editProfile/${this.$route.params.id}`, {
            firstname: this.auth_user.firstname,
            lastname: this.auth_user.lastname,
            email: this.auth_user.email,
            type: this.auth_user.type,
            state: "2679",
            localgovt: this.auth_user.localgovt,
            ward: this.auth_user.ward,
            dob: this.auth_user.dob,
            salary_number: this.auth_user.salary_number,
            gender: this.auth_user.gender,
            genotype: this.auth_user.genotype,
            institutional_id: this.auth_user.institutional_id,
            id_card_number: this.auth_user.id_card_number,
            point_of_care: this.auth_user.point_of_care,
            provider_id: this.auth_user.provider_id,
            sector: this.auth_user.sector,
            blood: this.auth_user.blood,
            user_image: this.auth_user.user_image,
            middlename: this.auth_user.middlename,
            nimc_number: this.auth_user.nimc_number,
            marital_status: this.auth_user.marital_status,
            org_id: this.auth_user.org_id,
            password: this.auth_user.password,
            phone_number: this.auth_user.phone_number,
            sectorType: this.auth_user.sectorType,
            category_of_vulnerable_group:
              this.auth_user.category_of_vulnerable_group,
            agency_name: this.auth_user.agency_name,
            address1: this.auth_user.address1,
            plan_type: this.auth_user.plan_type,
            place_of_work: this.auth_user.place_of_work,
            expiry_date: this.auth_user.expiry_date,
            community: this.auth_user.community,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("Enrollee updated Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            let response = error.response && error.response.data && error.response.data.errors;
            if (response) {
              this.$toasted.error(`${JSON.stringify(response)}`, {
                position: "top-center",
                duration: 3000,
              });
            }
          });
      },
      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/getorgenrollment/407465/A`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.fetchLga();
      this.getMDAs();
      this.getAgencyProgrammes();
      // this.getTPAs();
      this.getProviders();
    },
  };
</script>

<style scoped>
  /* ── Page Header ─────────────────────────────────────── */
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .header-icon-wrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* ── Table card ──────────────────────────────────────── */
  .table-card {
    border-radius: 14px;
    border: none;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
  }

  .section-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .info-label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #374151;
  }

  /* ── Submit Button ───────────────────────────────────── */
  .btn-submit {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-weight: 600;
  }

  .btn-submit:hover {
    opacity: 0.9;
    color: #fff;
  }

  .form-control:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.2);
  }
</style>
